import React from 'react';
import { Button, Grid } from '@material-ui/core';
import Status from '../shared/status';
import StatusState from '../shared/status/state';
import { useDispatch } from 'react-redux';
import { logout } from '../../store/actions/user.action';

const PaymentStatus = (props) => {
  const { status, error, onNewPayment, submit, editInfo } = props;
  const dispatch = useDispatch();

  if (status === false) return '';

  const handleLogout = () => dispatch(logout());

  return (
    <Status state={status}>
      <StatusState
        loading
        title="Submitting payment..."
        msg="Please do not refresh or close browser."
      />
      <StatusState
        success
        title="Payment Submitted!"
        msg="Please allow up to 1 business day for your payment to be processed; you will receive an email once it has."
      >
        <Grid container spacing={2} justify="center">
          <Grid item xs={9} sm={5}>
            <Button variant="outlined" onClick={onNewPayment} fullWidth>
              Make another payment
            </Button>
          </Grid>
          <Grid item xs={9} sm={5}>
            <Button variant="outlined" fullWidth onClick={handleLogout}>
              Logout
            </Button>
          </Grid>
        </Grid>
      </StatusState>
      <StatusState error title="Error" msg={error}>
        <Grid container spacing={2} justify="center">
          <Grid item xs={9} sm={3}>
            <Button variant="outlined" onClick={submit} fullWidth>
              Try Again
            </Button>
          </Grid>
          <Grid item xs={9} sm={3}>
            <Button variant="outlined" onClick={editInfo} fullWidth>
              Edit Info
            </Button>
          </Grid>
          <Grid item xs={9} sm={3}>
            <Button variant="outlined" onClick={handleLogout} fullWidth>
              Logout
            </Button>
          </Grid>
        </Grid>
      </StatusState>
    </Status>
  );
};
export default PaymentStatus;
